<template>
  <div class="homeCenter clearfix">
    <div class="titleBox">
      <h2>
        个人信息
        <button @click='toBack' class="btn btn-primary btn-lg btn-round d-block d-lg-none">商城 <i class="iconfont icon-more1"></i></button>
      </h2>
      <hr>
      <p class="content">管理您的个人信息，修改密码设置发票抬头等</p>
    </div>
    <div class="threeBox">
      <div class="box yuanjiao">
        <dl class="row">
          <dt class="col-sm-3">头像</dt>
          <dd class="col-sm-9" :key="saveUploadView">
            <vue-core-image-upload v-if="!is_loading" :key='saveUploadView'
                                   :crop="false"
                                   :inputOfFile="'UploadFormfile[imgFile]'"
                                   @imageuploaded="imageuploadedReload"
                                   @imagechanged="imagechangedReload"
                                   @imageuploading='imageuploading'
                                   @errorhandle='errorhandle'
                                   inputAccept='image/*'
                                   :maxFileSize='uploadSize'
                                   input-of-file="file"
                                   :isXhr='false'
                                   :data="{str:localUser.token}"
                                   :headers="{Authorization:localUser.token}"
                                   :url="uploadUrl">
              <div v-if="localUser.headPortrait === ''" class="uploadBox"><i class="iconfont icon-plus"></i></div>
              <div v-if="localUser.headPortrait !== ''" class="uploadBox" :style="{backgroundImage: 'url('+ossImgDomain+localUser.headPortrait+')'}"></div>
            </vue-core-image-upload>
            <div v-if="is_loading" class="uploadBox">
              <span>{{loadingSize}}</span>
              <span>{{loadingProgress}}%</span>
            </div>
          </dd>
        </dl>
        <hr>
        <br>
        <dl class="row">
          <dt class="col-sm-3">
            账号
          </dt>
          <dd class="col-sm-9">
            <p>
              {{localUser.user}}（{{localUser.userType==='2'?'账号注册':'手机号注册'}}）
            </p>
            <p>
              绑定邮箱：{{localUser.userType==='2'?localUser.email:'未填写邮箱'}}
            </p>
          </dd>
          <dt class="col-sm-3">名称</dt>
          <dd class="col-sm-9">
            <p>
              {{localUser.name?localUser.name:'······'}}
            </p>
            <p>
              <button type="button" @click="showModelBox('savename')" class="btn btn-outline-primary btn-round">修改名称</button>
            </p>
          </dd>
        </dl>
        <hr>
        <br>
        <dl class="row">
          <dt class="col-sm-3">企业发票抬头</dt>
          <dd class="col-sm-9">
            <p>发票抬头：{{localUser.invoiceInfo.title?localUser.invoiceInfo.title:'...'}}</p>
            <p>纳税人识别号：{{localUser.invoiceInfo.code?localUser.invoiceInfo.code:'...'}}</p>
            <p>开户银行：{{localUser.invoiceInfo.bank?localUser.invoiceInfo.bank:'...'}}</p>
            <p>银行账号：{{localUser.invoiceInfo.bankCode?localUser.invoiceInfo.bankCode:'...'}}</p>
            <p>注册电话：{{localUser.invoiceInfo.registerPhone?localUser.invoiceInfo.registerPhone:'...'}}</p>
            <p>注册地址：{{localUser.invoiceInfo.registerAddress?localUser.invoiceInfo.registerAddress:'...'}}</p>
            <p>
              <button type="button" @click="showModelBox('saveinvoice')" class="btn btn-outline-primary btn-round">修改抬头</button>
            </p>
          </dd>
        </dl>
        <hr>
        <br>
        <dl class="row">
          <dt class="col-sm-3">个人发票抬头</dt>
          <dd class="col-sm-9">
            <p>发票抬头：{{localUser.invoiceInfo.person?localUser.invoiceInfo.person:'...'}}</p>
            <p>
              <button type="button" @click="showModelBox('saveinvoiceperson')" class="btn btn-outline-primary btn-round">修改抬头</button>
            </p>
          </dd>
        </dl>
        <hr>
        <br>
        <dl class="row">
          <dt class="col-sm-3">预定义收件地址</dt>
          <dd class="col-sm-9">
            <p>收件人：{{localUser.invoiceInfo.mailName?localUser.invoiceInfo.mailName:'...'}}</p>
            <p>收件电话：{{localUser.invoiceInfo.mailPhone?localUser.invoiceInfo.mailPhone:'...'}}</p>
            <p>收件地址：{{localUser.invoiceInfo.mailAddress?localUser.invoiceInfo.mailAddress:'...'}}</p>
            <p>
              <button type="button" @click="showModelBox('saveinvoicepost')" class="btn btn-outline-primary btn-round">修改信息</button>
            </p>
          </dd>
        </dl>
      </div>
    </div>
    <transition appear mode='out-in' enter-active-class='animated animated2 slideInRight' leave-active-class='animated animated2 slideOutRight'>
      <div v-if="isShowRightBox" class="rightBox" @click.self="closeRightBoxFun">
        <component :hide="false" :closeRightBoxFun="closeRightBoxFun" :parameter="parameter" :is="isCompnentElement"></component>
      </div>
    </transition>
  </div>
</template>

<script>
import { EventBus } from '@/util/eventBus';
import uiSavename from '@/components/common/user/Savename';
import uiSaveinvoice from '@/components/common/user/Saveinvoice';
import uiSaveinvoiceperson from '@/components/common/user/Saveinvoiceperson';
import uiSaveinvoicepost from '@/components/common/user/Saveinvoicepost';
import generalMix from '@/util/mix/general';
import VueCoreImageUpload from 'vue-core-image-upload'; // 图片上传组件
import commons from '@/util/commons';
import resultcommons from '../../util/resultcommons'; // 引入通用函数
import * as types from '@/store/types';

export default {
  name: 'homeCenter',
  mixins: [generalMix],
  data () {
    return {
      isShowRightBox: false,
      isCompnentElement: '',
      parameter: {},
      // 上传状态参数
      uploadUrl: process.env.IMAGE_UPLOAD_URL, // 图片上传地址
      uploadSize: process.env.IMAGE_UPLOAD_SIZE,
      ossImgDomain: process.env.OSS_IMG_DOMAIN,
      is_loading: false, // 上传按钮状态
      loadingSize: '0 B', // 文件大小
      loadingProgress: 0, // 上传进度
      saveUploadView: 0
    }
  },
  methods:{
    imageuploadedReload(res) {
    },
    imagechangedReload(ob) {
      commons.makeTupianOneImgShard(this, ob, { token: this.token, type: 'crmdataheadimg', initFun: this.initUploadSuccess }, 'reload');
    },
    imageuploading() {
      // 上传中
    },
    errorhandle(message) {
      // 上传选择后
      this.$message.showMsgBox({
        type: 'danger',
        content: message
      });
      this.is_loading = false;
      this.saveUploadView = this.saveUploadView + 1;
    },
    // 初始化详情
    initUploadSuccess(ob) {
      // 成功的话就执行更新请求
      if(ob.state === 200){
        this.is_loading = true;
        EventBus.$emit('globalLoadingFun', {bool:true,loading:true});
        resultcommons.apiSaveheadportrait(this,{path:ob.data.path}).then(app=>{
          if(app.state === 200){
            // 更新本地缓存
            const localOb = this.localUser;
            localOb.headPortrait = app.data.headPortrait;
            commons.saveTodos('localUser', localOb);
            // 更新本地路由的登录信息
            this.$store.commit(types.SAVE_LOCALUSER, { bool: true });
            // 提示
            this.$message.showMsgBox({
              type: 'success',
              content: app.message
            });
          }else{
            // 提示
            this.$message.showMsgBox({
              type: 'warning',
              content: app.message
            });
          }
          // 失败了
          this.is_loading = false;
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
        });
      }
    },
    showModelBox(type) {
      this.parameter = {};
      if(type === 'savename'){
        this.isCompnentElement = 'ui-savename';
      }else if(type === 'saveinvoiceperson'){
        this.isCompnentElement = 'ui-saveinvoice-person';
      }else if(type === 'saveinvoicepost'){
        this.isCompnentElement = 'ui-saveinvoice-post';
      }else{
        this.isCompnentElement = 'ui-saveinvoice';
      }
      $('html').addClass('scrollHide');
      this.isShowRightBox = true;
    },
    closeRightBoxFun() {
      this.isShowRightBox = false;
      this.parameter = {};
      this.isCompnentElement = '';
      $('html').removeClass('scrollHide');
    },
    showWeicode(ob) {
      EventBus.$emit('globalRightBoxFun', ob);
    }
  },
  components: {
    'ui-savename': uiSavename,
    'ui-saveinvoice': uiSaveinvoice,
    'ui-saveinvoice-person': uiSaveinvoiceperson,
    'ui-saveinvoice-post': uiSaveinvoicepost,
    VueCoreImageUpload
  },
  mounted() {
    $('html').removeClass('scrollHide');
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.homeCenter {
  .titleBox {
    margin-top: 30px;
    margin-bottom: 30px;
    p {
      margin: 0;
    }
  }
  div.uploadBox{
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background-color: #E5E5E5;
    display: flex;
    justify-content: center;
    align-items: center;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    flex-direction: column;
    i{
      font-size: 32px;
      color: rgba(0,0,0,0.5);
    }
    span{
      display: block;
      width: 100%;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 5px;
    }
  }
  .rightBox{
    position: fixed;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 4;
  }
  div.threeBox {
    margin-top: 20px;
    color: #000000;
    min-height: 100vh;
    div.box {
      /*background: #FFFFFF;*/
      padding: 40px 40px;
      /*box-shadow: 0 .75rem 1.5rem rgba(18, 38, 63, .03);*/
      div.lis{
        margin-bottom: 50px;
        h4{
          margin-bottom: 20px;
        }
        div.content{
          margin-bottom: 10px;
        }
        div.anli{
          margin-top: 20px;
          display: flex;
          div.card{
            background: #FFFFFF url("/static/images/engage.svg") no-repeat 115px 110px;
            background-size: 65px;
            &:first-child{
              margin-right: 20px;
            }
          }
        }
        ul{
          li{
            float: left;
            margin-right: 15px;
            &:after{
              margin-left: 15px;
              display: inline-block;
              content: '->';
            }
            &:last-child{
              margin: 0;
              &:after{
                display: none;
              }
            }
          }
        }
        &:last-child{
          margin: 0;
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .homeCenter{
    .titleBox {
      margin-top: 0;
      h2{
        display: flex;
        justify-content: space-between;
      }
      p {
        margin: 0;
        color: #9B9B9B;
      }
    }
    div.threeBox {
      margin-top: 20px;
      div.box {
        background: #FFFFFF;
        padding: 20px 20px;
        dl{
          dt{
            margin-bottom: 10px;
            font-size: 14px;
            color: rgba(0,0,0,0.4);
          }
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .homeCenter{
    .titleBox {
      p{
        padding: 0 15px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/info/Center.vue